
<script lang="ts" setup>
import { useGlobalData } from '@/utils/useGlobal';
import Popup from "@/components/global/Popup.vue";
import { isShowWxPop, showSocialPop, close } from "../socialMedia"
import SociaMediaQrCodePop from "./SociaMediaQrCodePop.vue";

defineProps({
  clx: {
    type: String,
    default: ""
  },
})

const { config } = useGlobalData()

</script>
<template>
  <div class="contact-wrap" :class="`${clx}`" >
    <div class="contact-content">
      <ul class="contact-list">
        <li class="contact-item active" @click="showSocialPop('bilibili')">
          <span class="icon-bilibili" />
        </li>
        <li class="contact-item" @click="showSocialPop('weibo')">
          <span class="icon-weibo" />
        </li>
        <li class="contact-item" @click="showSocialPop('weixin')">
          <span class="icon-weixin" />
        </li>
        <!-- <li class="contact-item" @click="showSocialPop('qqkj')">
          <span class="icon-qqkj" />
        </li> -->
        <li class="contact-item" @click="showSocialPop('douyin')">
          <span class="icon-dy" />
        </li>
        <li class="contact-item" @click="showSocialPop('xiaohongshu')">
          <span class="icon-xhs" />
        </li>
       
        <li class="contact-item active" @click="showSocialPop('qq')">
          <span class="icon-qq" />
        </li>
        <li class="contact-item active" @click="showSocialPop('customer-service')">
          <span class="icon-customer-service" />
        </li>
      </ul>
    </div>
  </div>
  <popup :value="isShowWxPop"  @input="close">
    <div class="popup_wrap">
      <div v-if="config.socialMedia.weixin" class="contact-pop">
        <div class="qrcode-box">
          <img :src="config.socialMedia.weixin" alt="微信公众号" class="wx-img">
          <p class="wx-desc">{{ config.socialMedia.weixinDesc }}</p>
        </div>
        <div class="qrcode-box">
          <img :src="config.socialMedia.weixinxiaochengxu" alt="微信小程序" class="wx-img">
          <p class="wx-desc">{{ config.socialMedia.weixinxiaochengxuDesc }}</p>
        </div>
      </div>
      <button class="close" @click="close"></button>
    </div>
  </popup>

  <SociaMediaQrCodePop />

</template>
<style lang="less" scoped>
@import "@/assets/css/socialMedia.less";

.contact-content{
  display: flex;
  align-items: center;
}
.contact-list {
  display: flex;
  justify-content: space-between;
 
  .contact-item {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 0.4rem;
    height: 100%;
    overflow: hidden;
    cursor: pointer;
    & > span{
      display: block;
      width: 100%;
      height: 100%;
      transition: all .3s;
    }
    .icon-bilibili{
      background: url("~/images/media/bilibili.png") no-repeat center center;
      background-size: 100% 100%;
    }
    .icon-weibo{
      background: url("~/images/media/weibo.png") no-repeat center center;
      background-size: 100% 100%;
    }
    .icon-weixin{
      background: url("~/images/media/weixin.png") no-repeat center center;
      background-size: 100% 100%;
    }
    // .icon-qqkj{
    //   background: url("~/images/media/qqkj.png") no-repeat center center;
    //   background-size: 100% 100%;
    // }
    .icon-qq{
      background: url("~/images/media/qq.png") no-repeat center center;
      background-size: 100% 100%;
    }
    .icon-dy{
      background: url("~/images/media/douyin.png") no-repeat center center;
      background-size: 100% 100%;
    }
    .icon-xhs{
      background: url("~/images/media/xiaohongshu.png") no-repeat center center;
      background-size: 100% 100%;
    }
    .icon-customer-service {
      background: url("~/images/media/customer-service.png") no-repeat center center;
      background-size: 100% 100%;
    }
  }
  .wx-img {
    width: 0.96rem;
  }
}
.animate-share {
  animation: fadeInUpZoom 0.2s forwards;
}
.arrow{
  display: inline-block;
  width: 0;
  height: 0;
  border-top: 0.15rem solid red;
  border-right: 0.1rem solid transparent;
  border-left: 0.1rem solid transparent;
  transition: all 0.2s;
  transform: rotate(90deg);
  
  &.open{
    transform: rotate(-90deg);
  }
}

.pc{
  .contact-wrap{
    position: fixed;
    bottom: 0.3rem;
    left: 0.18rem;
    z-index: 1;
  }
  .contact-list {
    height: 0.4rem;
  }
  .contact-item {
    &:hover{
      .icon-bilibili{
        background: url("~/images/media/bilibili-h.png") no-repeat center center;
        background-size: 100% 100%;
      }
      .icon-weibo{
        background: url("~/images/media/weibo-h.png") no-repeat center center;
        background-size: 100% 100%;
      }
      .icon-weixin{
        background: url("~/images/media/weixin-h.png") no-repeat center center;
        background-size: 100% 100%;
      }
      .icon-qqkj{
        background: url("~/images/media/qqkj-h.png") no-repeat center center;
        background-size: 100% 100%;
      }
      .icon-qq{
        background: url("~/images/media/qq-h.png") no-repeat center center;
        background-size: 100% 100%;
      }
      .icon-dy{
        background: url("~/images/media/douyin-h.png") no-repeat center center;
        background-size: 100% 100%;
      }
      .icon-xhs{
        background: url("~/images/media/xiaohongshu-h.png") no-repeat center center;
        background-size: 100% 100%;
      }
      .icon-customer-service{
        background: url("~/images/media/customer-service-h.png?v=1.0") no-repeat center center;
        background-size: 100% 100%;
      }
    }
  }
}
.wap{
  .contact-list {
    height: 0.6rem;
  }
  .contact-item {
    width: 0.6rem;
  }
}

@keyframes fadeIn {

  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }

}

</style>
